import type { ElementType, ComponentPropsWithoutRef, ReactNode } from 'react'

import { cn } from '@/lib/cn'

interface GlassCardProps<T extends ElementType> {
  as?: T
  /** Add the hover/focus glow affordance (for cards that are themselves links). */
  interactive?: boolean
  className?: string
  children: ReactNode
}

const SURFACE =
  'glass rounded-lg border border-glass-border bg-surface-slate/40 backdrop-blur-glass'

const INTERACTIVE =
  'transition-[box-shadow,border-color] duration-300 ' +
  'hover:border-primary-container/50 hover:shadow-glow ' +
  'focus-within:border-primary-container/50 focus-within:shadow-glow'

export function GlassCard<T extends ElementType = 'div'>({
  as,
  interactive = false,
  className,
  children,
  ...rest
}: GlassCardProps<T> &
  Omit<ComponentPropsWithoutRef<T>, keyof GlassCardProps<T>>) {
  const Tag = (as ?? 'div') as ElementType
  return (
    <Tag
      className={cn(SURFACE, interactive && INTERACTIVE, className)}
      {...rest}
    >
      {children}
    </Tag>
  )
}
